import PropTypes from 'prop-types'

import {
  SectionTitle,
  CodeWrapper,
  CodeBlock
} from 'components/common/Codeblock'
import { CopyButton } from 'components/common/CopyButton'
import theme from 'theme'

const CentOS = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Add the Gremlin repo:
        </SectionTitle>
        <CopyButton
          colorTheme={colorTheme}
          content="sudo curl https://rpm.gremlin.com/gremlin.repo -o /etc/yum.repos.d/gremlin.repo"
        />
      </div>

      <CodeBlock code="sudo curl https://rpm.gremlin.com/gremlin.repo -o /etc/yum.repos.d/gremlin.repo" />
    </div>

    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <SectionTitle colorTheme={colorTheme}>
          Install Gremlin client and daemon:
        </SectionTitle>
        <CopyButton
          colorTheme={colorTheme}
          content="sudo yum install -y gremlin gremlind"
        />
      </div>
      <CodeBlock code="sudo yum install -y gremlin gremlind" />
    </div>
  </CodeWrapper>
)

CentOS.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}
export default CentOS
